import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledAllRightsReservedComponent } from "./all-rights-reserved-component.scss.js";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withRouter } from "next/router";
class AllRightsReservedComponent extends PureComponent {
    getText() {
        const { translate } = this.props;
        return translate("allRightsReserved");
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledAllRightsReservedComponent, {
            className: "all-rights-reserved-component",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "details",
                children: [
                    this.getText(),
                    " © monday.com"
                ]
            })
        });
    }
}
export default withGenericConfig(withRouter(AllRightsReservedComponent));
